import { useState } from "react";
import { adminSetStaffPin } from "@/lib/api";

const PinRow = ({ role, title, hint }) => {
    const [pin, setPin] = useState("");
    const [msg, setMsg] = useState(null);
    const save = async () => {
        setMsg(null);
        try { await adminSetStaffPin(role, pin); setPin(""); setMsg({ ok: true, t: "Saved ✓" }); }
        catch (e) { setMsg({ ok: false, t: e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Couldn't save" }); }
    };
    return (
        <div className="border-2 border-[var(--border)] p-4 mb-3" data-testid={`staff-pin-row-${role}`}>
            <div className="font-display text-[18px] leading-tight">{title}</div>
            <p className="text-muted text-[13px] mb-3">{hint}</p>
            <div className="flex gap-3">
                <input className="input max-w-[180px] tracking-[0.4em]" type="password" inputMode="numeric" maxLength={6} placeholder="New PIN"
                    value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} data-testid={`staff-pin-input-${role}`} />
                <button className="btn-secondary" disabled={pin.length < 4} onClick={save} data-testid={`staff-pin-save-${role}`}>Change PIN</button>
            </div>
            {msg && <p className={`font-mono text-[11px] mt-2 ${msg.ok ? "text-gold" : "text-[#ff5246]"}`} data-testid={`staff-pin-msg-${role}`}>{String(msg.t)}</p>}
        </div>
    );
};

export const StaffPinsSection = () => (
    <>
        <PinRow role="staff" title="Staff PIN" hint="Hub, Counter and kiosk setup. Sees each order's total but not the day's revenue." />
        <PinRow role="manager" title="Manager PIN" hint="Same screens, plus the day's revenue and full totals." />
    </>
);
